<template>
    <v-container grid-list-lg>
        <v-layout row>
            <v-flex xs12 class="text-xs-center display-1 font-weight-black my-5"
                >Live events</v-flex
            >
            <v-flex
                xs12
                class="text-xs-center display-1 font-weight-black my-5"
                >{{ raceData.nomeGara }}</v-flex
            >
        </v-layout>
        <v-layout row wrap class="meal-plans">
            <v-flex xs12 sm12 md4>
                <v-card>
                    <v-responsive>
                        <v-img
                            src="https://scontent-fco1-1.xx.fbcdn.net/v/t1.0-9/149340065_756059135047297_8594446557936704079_n.jpg?_nc_cat=106&ccb=3&_nc_sid=8bfeb9&_nc_ohc=67zaIuCIghQAX85hOUK&_nc_ht=scontent-fco1-1.xx&oh=63c424b1fd2f28e54ff066fd7e596538&oe=604F5046"
                            height="500px"
                        >
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="headline white--text"
                                            >WORLD CUP</span
                                        >
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>
                    </v-responsive>

                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Keto</h3>
                            <div>
                                The Keto diet is a high-fat, adequate-protein,
                                low-carbohydrate diet. The diet forces the body
                                to burn fats rather than carbohydrates by
                                putting the body into ketosis.
                            </div>
                        </div>
                    </v-card-text>

                    <v-card-actions v-if="['menu'].includes($route.name)">
                        <v-btn
                            outline
                            block
                            color="green"
                            @click="showRecipes('keto')"
                            data-cy="plansKetoBtn"
                        >
                            Select This Plan</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md4>
                <v-card>
                    <v-responsive>
                        <v-img
                            src="https://www.icron.it//configurazioni-gare/20211115/20211115_3OUmZDxLKziN0oqNFm4EhBHCi6Q59zKebufQtNoFQPg=.png"
                            height="500px"
                        >
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="headline white--text"
                                            >CROSS DUATHLON</span
                                        >
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>
                    </v-responsive>

                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Paleo</h3>
                            <div>
                                The Paleo diet requires the predominant
                                consumption of foods presumed to have been the
                                only foods available to or consumed by humans
                                during the Paleolithic era.
                            </div>
                        </div>
                    </v-card-text>

                    <v-card-actions v-if="['menu'].includes($route.name)">
                        <v-btn
                            outline
                            block
                            color="green"
                            @click="showRecipes('paleo')"
                            data-cy="plansPaleoBtn"
                        >
                            Select This Plan</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md4>
                <v-card>
                    <v-responsive>
                        <v-img
                            src="https://www.icron.it//configurazioni-gare/20211116/20211116_YHuI4hUBPntXGcD5q2oTFCNMG5vz5lY2nTmx5bSrmqk=.jpeg"
                            height="500px"
                        >
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="headline white--text"
                                            >CAMPIONATO ITALIANO</span
                                        >
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>
                    </v-responsive>

                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Vegan</h3>
                            <div>
                                The vegan diet abstains from the use of animal
                                products. The vegan diet does not consume meat,
                                diary products, eggs or any all other
                                animal-derived ingredients.
                            </div>
                        </div>
                    </v-card-text>

                    <v-card-actions v-if="['menu'].includes($route.name)">
                        <v-btn
                            outline
                            block
                            color="green"
                            @click="showRecipes('vegan')"
                            data-cy="plansVeganBtn"
                        >
                            Select This Plan</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'HomePlans',
    beforeCreate() {
        this.$options.sockets = {
            onmessage: (data) => this.showClassifica(data),
        };
    },

    data() {
        return {
            raceData: { raceName: '' },
        };
    },
    mounted() {},
    methods: {
        showClassifica(data) {
            console.log('SHOW CLASSIFICA');
            console.log(data);
            this.raceData = JSON.parse(data.data);
        },

        closeClassifica(data) {
            console.log('closeClassifica');
        },
    },
};
</script>

<style scoped></style>
